import { breakpoints } from '@ds/ui';

const breakpointSizes = {
    xxxs: 400,
    xxs: breakpoints.Sizes.ExtraSmall,
    xs: breakpoints.Sizes.Small,
    s: breakpoints.Sizes.Medium
};

export default breakpointSizes;
